import type * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuthorQuestionCountsQueryVariables = Types.Exact<{
  authorId: Types.Scalars['ID']['input'];
  yearStart: Types.Scalars['DateTime']['input'];
  monthStart: Types.Scalars['DateTime']['input'];
}>;


export type AuthorQuestionCountsQuery = { __typename?: 'RootQueryType', authored?: { __typename?: 'PageOfQuestion', count?: number | null } | null, allTime?: { __typename?: 'PageOfQuestion', count?: number | null } | null, thisYear?: { __typename?: 'PageOfQuestion', count?: number | null } | null, thisMonth?: { __typename?: 'PageOfQuestion', count?: number | null } | null };

export type AuthorRecentQuestionsQueryVariables = Types.Exact<{
  authorId: Types.Scalars['ID']['input'];
  publishedSince: Types.Scalars['DateTime']['input'];
  feedbackQuestionIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type AuthorRecentQuestionsQuery = { __typename?: 'RootQueryType', questionsOffset?: { __typename?: 'PageOfQuestion', results?: Array<{ __typename?: 'Question', id: string, title?: string | null, status: Types.QuestionStatus, questionSetId?: string | null, unfilteredSubject: { __typename?: 'Subject', id: string, name: string } }> | null } | null };

export type AuthorPublishedActivityQueryVariables = Types.Exact<{
  authorId: Types.Scalars['ID']['input'];
  publishedSince: Types.Scalars['DateTime']['input'];
}>;


export type AuthorPublishedActivityQuery = { __typename?: 'RootQueryType', questionsOffset?: { __typename?: 'PageOfQuestion', results?: Array<{ __typename?: 'Question', id: string, title?: string | null, questionSetId?: string | null, publishedAt?: any | null, unfilteredSubject: { __typename?: 'Subject', id: string, name: string } }> | null } | null };

export type AuthorPublishedQuestionMetricsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.QuestionFilterInput>;
  offset: Types.Scalars['Int']['input'];
}>;


export type AuthorPublishedQuestionMetricsQuery = { __typename?: 'RootQueryType', questionsOffset?: { __typename?: 'PageOfQuestion', results?: Array<{ __typename?: 'Question', id: string, publishedAt?: any | null, difficulty?: number | null, questionType: string }> | null } | null };

export type AuthorDashboardRecentFeedbackQueryVariables = Types.Exact<{
  updatedSince: Types.Scalars['DateTime']['input'];
  userId: Types.Scalars['ID']['input'];
}>;


export type AuthorDashboardRecentFeedbackQuery = { __typename?: 'RootQueryType', authoringFeedbacks?: { __typename?: 'KeysetPageOfAuthoringFeedback', results?: Array<{ __typename?: 'AuthoringFeedback', id: string, message: string, questionId: string, updatedAt: any, userInfo?: { __typename?: 'AuthoringFeedbackUserInfo', firstName?: string | null, lastName?: string | null } | null, question: { __typename?: 'Question', id: string, title?: string | null, questionSetId?: string | null, unfilteredSubject: { __typename?: 'Subject', name: string } } }> | null } | null };

export type AuthorProfileQueryVariables = Types.Exact<{
  authorId: Types.Scalars['ID']['input'];
}>;


export type AuthorProfileQuery = { __typename?: 'RootQueryType', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username: string, email: string, insertedAt: any, subjectAuthors: Array<{ __typename?: 'SubjectAuthor', id: string, unfilteredSubject: { __typename?: 'Subject', id: string, name: string } }> } | null };


export const AuthorQuestionCountsDocument = gql`
    query AuthorQuestionCounts($authorId: ID!, $yearStart: DateTime!, $monthStart: DateTime!) {
  authored: questionsOffset(filter: {authorId: {eq: $authorId}}, limit: 1) {
    count
  }
  allTime: questionsOffset(
    filter: {authorId: {eq: $authorId}, status: {eq: PUBLISHED}}
    limit: 1
  ) {
    count
  }
  thisYear: questionsOffset(
    filter: {authorId: {eq: $authorId}, status: {eq: PUBLISHED}, publishedAt: {greaterThan: $yearStart}}
    limit: 1
  ) {
    count
  }
  thisMonth: questionsOffset(
    filter: {authorId: {eq: $authorId}, status: {eq: PUBLISHED}, publishedAt: {greaterThan: $monthStart}}
    limit: 1
  ) {
    count
  }
}
    `;

/**
 * __useAuthorQuestionCountsQuery__
 *
 * To run a query within a React component, call `useAuthorQuestionCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorQuestionCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorQuestionCountsQuery({
 *   variables: {
 *      authorId: // value for 'authorId'
 *      yearStart: // value for 'yearStart'
 *      monthStart: // value for 'monthStart'
 *   },
 * });
 */
export function useAuthorQuestionCountsQuery(baseOptions: Apollo.QueryHookOptions<AuthorQuestionCountsQuery, AuthorQuestionCountsQueryVariables> & ({ variables: AuthorQuestionCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorQuestionCountsQuery, AuthorQuestionCountsQueryVariables>(AuthorQuestionCountsDocument, options);
      }
export function useAuthorQuestionCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorQuestionCountsQuery, AuthorQuestionCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorQuestionCountsQuery, AuthorQuestionCountsQueryVariables>(AuthorQuestionCountsDocument, options);
        }
// @ts-ignore
export function useAuthorQuestionCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthorQuestionCountsQuery, AuthorQuestionCountsQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorQuestionCountsQuery, AuthorQuestionCountsQueryVariables>;
export function useAuthorQuestionCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorQuestionCountsQuery, AuthorQuestionCountsQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorQuestionCountsQuery | undefined, AuthorQuestionCountsQueryVariables>;
export function useAuthorQuestionCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorQuestionCountsQuery, AuthorQuestionCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorQuestionCountsQuery, AuthorQuestionCountsQueryVariables>(AuthorQuestionCountsDocument, options);
        }
export type AuthorQuestionCountsQueryHookResult = ReturnType<typeof useAuthorQuestionCountsQuery>;
export type AuthorQuestionCountsLazyQueryHookResult = ReturnType<typeof useAuthorQuestionCountsLazyQuery>;
export type AuthorQuestionCountsSuspenseQueryHookResult = ReturnType<typeof useAuthorQuestionCountsSuspenseQuery>;
export type AuthorQuestionCountsQueryResult = Apollo.QueryResult<AuthorQuestionCountsQuery, AuthorQuestionCountsQueryVariables>;
export const AuthorRecentQuestionsDocument = gql`
    query AuthorRecentQuestions($authorId: ID!, $publishedSince: DateTime!, $feedbackQuestionIds: [ID!]!) {
  questionsOffset(
    filter: {authorId: {eq: $authorId}, or: [{publishedAt: {greaterThanOrEqual: $publishedSince}}, {id: {in: $feedbackQuestionIds}}]}
    sort: [{field: UPDATED_AT, order: DESC}]
    limit: 250
  ) {
    results {
      id
      title
      status
      questionSetId
      unfilteredSubject {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAuthorRecentQuestionsQuery__
 *
 * To run a query within a React component, call `useAuthorRecentQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorRecentQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorRecentQuestionsQuery({
 *   variables: {
 *      authorId: // value for 'authorId'
 *      publishedSince: // value for 'publishedSince'
 *      feedbackQuestionIds: // value for 'feedbackQuestionIds'
 *   },
 * });
 */
export function useAuthorRecentQuestionsQuery(baseOptions: Apollo.QueryHookOptions<AuthorRecentQuestionsQuery, AuthorRecentQuestionsQueryVariables> & ({ variables: AuthorRecentQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorRecentQuestionsQuery, AuthorRecentQuestionsQueryVariables>(AuthorRecentQuestionsDocument, options);
      }
export function useAuthorRecentQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorRecentQuestionsQuery, AuthorRecentQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorRecentQuestionsQuery, AuthorRecentQuestionsQueryVariables>(AuthorRecentQuestionsDocument, options);
        }
// @ts-ignore
export function useAuthorRecentQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthorRecentQuestionsQuery, AuthorRecentQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorRecentQuestionsQuery, AuthorRecentQuestionsQueryVariables>;
export function useAuthorRecentQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorRecentQuestionsQuery, AuthorRecentQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorRecentQuestionsQuery | undefined, AuthorRecentQuestionsQueryVariables>;
export function useAuthorRecentQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorRecentQuestionsQuery, AuthorRecentQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorRecentQuestionsQuery, AuthorRecentQuestionsQueryVariables>(AuthorRecentQuestionsDocument, options);
        }
export type AuthorRecentQuestionsQueryHookResult = ReturnType<typeof useAuthorRecentQuestionsQuery>;
export type AuthorRecentQuestionsLazyQueryHookResult = ReturnType<typeof useAuthorRecentQuestionsLazyQuery>;
export type AuthorRecentQuestionsSuspenseQueryHookResult = ReturnType<typeof useAuthorRecentQuestionsSuspenseQuery>;
export type AuthorRecentQuestionsQueryResult = Apollo.QueryResult<AuthorRecentQuestionsQuery, AuthorRecentQuestionsQueryVariables>;
export const AuthorPublishedActivityDocument = gql`
    query AuthorPublishedActivity($authorId: ID!, $publishedSince: DateTime!) {
  questionsOffset(
    filter: {authorId: {eq: $authorId}, publishedAt: {greaterThanOrEqual: $publishedSince}}
    sort: [{field: PUBLISHED_AT, order: DESC}]
    limit: 250
  ) {
    results {
      id
      title
      questionSetId
      publishedAt
      unfilteredSubject {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAuthorPublishedActivityQuery__
 *
 * To run a query within a React component, call `useAuthorPublishedActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorPublishedActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorPublishedActivityQuery({
 *   variables: {
 *      authorId: // value for 'authorId'
 *      publishedSince: // value for 'publishedSince'
 *   },
 * });
 */
export function useAuthorPublishedActivityQuery(baseOptions: Apollo.QueryHookOptions<AuthorPublishedActivityQuery, AuthorPublishedActivityQueryVariables> & ({ variables: AuthorPublishedActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorPublishedActivityQuery, AuthorPublishedActivityQueryVariables>(AuthorPublishedActivityDocument, options);
      }
export function useAuthorPublishedActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorPublishedActivityQuery, AuthorPublishedActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorPublishedActivityQuery, AuthorPublishedActivityQueryVariables>(AuthorPublishedActivityDocument, options);
        }
// @ts-ignore
export function useAuthorPublishedActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthorPublishedActivityQuery, AuthorPublishedActivityQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorPublishedActivityQuery, AuthorPublishedActivityQueryVariables>;
export function useAuthorPublishedActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorPublishedActivityQuery, AuthorPublishedActivityQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorPublishedActivityQuery | undefined, AuthorPublishedActivityQueryVariables>;
export function useAuthorPublishedActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorPublishedActivityQuery, AuthorPublishedActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorPublishedActivityQuery, AuthorPublishedActivityQueryVariables>(AuthorPublishedActivityDocument, options);
        }
export type AuthorPublishedActivityQueryHookResult = ReturnType<typeof useAuthorPublishedActivityQuery>;
export type AuthorPublishedActivityLazyQueryHookResult = ReturnType<typeof useAuthorPublishedActivityLazyQuery>;
export type AuthorPublishedActivitySuspenseQueryHookResult = ReturnType<typeof useAuthorPublishedActivitySuspenseQuery>;
export type AuthorPublishedActivityQueryResult = Apollo.QueryResult<AuthorPublishedActivityQuery, AuthorPublishedActivityQueryVariables>;
export const AuthorPublishedQuestionMetricsDocument = gql`
    query AuthorPublishedQuestionMetrics($filter: QuestionFilterInput, $offset: Int!) {
  questionsOffset(filter: $filter, limit: 250, offset: $offset) {
    results {
      id
      publishedAt
      difficulty
      questionType
    }
  }
}
    `;

/**
 * __useAuthorPublishedQuestionMetricsQuery__
 *
 * To run a query within a React component, call `useAuthorPublishedQuestionMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorPublishedQuestionMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorPublishedQuestionMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAuthorPublishedQuestionMetricsQuery(baseOptions: Apollo.QueryHookOptions<AuthorPublishedQuestionMetricsQuery, AuthorPublishedQuestionMetricsQueryVariables> & ({ variables: AuthorPublishedQuestionMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorPublishedQuestionMetricsQuery, AuthorPublishedQuestionMetricsQueryVariables>(AuthorPublishedQuestionMetricsDocument, options);
      }
export function useAuthorPublishedQuestionMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorPublishedQuestionMetricsQuery, AuthorPublishedQuestionMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorPublishedQuestionMetricsQuery, AuthorPublishedQuestionMetricsQueryVariables>(AuthorPublishedQuestionMetricsDocument, options);
        }
// @ts-ignore
export function useAuthorPublishedQuestionMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthorPublishedQuestionMetricsQuery, AuthorPublishedQuestionMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorPublishedQuestionMetricsQuery, AuthorPublishedQuestionMetricsQueryVariables>;
export function useAuthorPublishedQuestionMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorPublishedQuestionMetricsQuery, AuthorPublishedQuestionMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorPublishedQuestionMetricsQuery | undefined, AuthorPublishedQuestionMetricsQueryVariables>;
export function useAuthorPublishedQuestionMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorPublishedQuestionMetricsQuery, AuthorPublishedQuestionMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorPublishedQuestionMetricsQuery, AuthorPublishedQuestionMetricsQueryVariables>(AuthorPublishedQuestionMetricsDocument, options);
        }
export type AuthorPublishedQuestionMetricsQueryHookResult = ReturnType<typeof useAuthorPublishedQuestionMetricsQuery>;
export type AuthorPublishedQuestionMetricsLazyQueryHookResult = ReturnType<typeof useAuthorPublishedQuestionMetricsLazyQuery>;
export type AuthorPublishedQuestionMetricsSuspenseQueryHookResult = ReturnType<typeof useAuthorPublishedQuestionMetricsSuspenseQuery>;
export type AuthorPublishedQuestionMetricsQueryResult = Apollo.QueryResult<AuthorPublishedQuestionMetricsQuery, AuthorPublishedQuestionMetricsQueryVariables>;
export const AuthorDashboardRecentFeedbackDocument = gql`
    query AuthorDashboardRecentFeedback($updatedSince: DateTime!, $userId: ID!) {
  authoringFeedbacks(
    filter: {updatedAt: {greaterThanOrEqual: $updatedSince}, question: {authorId: {eq: $userId}}}
    sort: [{field: UPDATED_AT, order: DESC}]
    first: 250
  ) {
    results {
      id
      message
      questionId
      updatedAt
      userInfo {
        firstName
        lastName
      }
      question {
        id
        title
        questionSetId
        unfilteredSubject {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAuthorDashboardRecentFeedbackQuery__
 *
 * To run a query within a React component, call `useAuthorDashboardRecentFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorDashboardRecentFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorDashboardRecentFeedbackQuery({
 *   variables: {
 *      updatedSince: // value for 'updatedSince'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAuthorDashboardRecentFeedbackQuery(baseOptions: Apollo.QueryHookOptions<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables> & ({ variables: AuthorDashboardRecentFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>(AuthorDashboardRecentFeedbackDocument, options);
      }
export function useAuthorDashboardRecentFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>(AuthorDashboardRecentFeedbackDocument, options);
        }
// @ts-ignore
export function useAuthorDashboardRecentFeedbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>;
export function useAuthorDashboardRecentFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorDashboardRecentFeedbackQuery | undefined, AuthorDashboardRecentFeedbackQueryVariables>;
export function useAuthorDashboardRecentFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>(AuthorDashboardRecentFeedbackDocument, options);
        }
export type AuthorDashboardRecentFeedbackQueryHookResult = ReturnType<typeof useAuthorDashboardRecentFeedbackQuery>;
export type AuthorDashboardRecentFeedbackLazyQueryHookResult = ReturnType<typeof useAuthorDashboardRecentFeedbackLazyQuery>;
export type AuthorDashboardRecentFeedbackSuspenseQueryHookResult = ReturnType<typeof useAuthorDashboardRecentFeedbackSuspenseQuery>;
export type AuthorDashboardRecentFeedbackQueryResult = Apollo.QueryResult<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>;
export const AuthorProfileDocument = gql`
    query AuthorProfile($authorId: ID!) {
  user(id: $authorId) {
    id
    firstName
    lastName
    username
    email
    insertedAt
    subjectAuthors(filter: {unfilteredSubject: {published: {eq: true}}}) {
      id
      unfilteredSubject {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAuthorProfileQuery__
 *
 * To run a query within a React component, call `useAuthorProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorProfileQuery({
 *   variables: {
 *      authorId: // value for 'authorId'
 *   },
 * });
 */
export function useAuthorProfileQuery(baseOptions: Apollo.QueryHookOptions<AuthorProfileQuery, AuthorProfileQueryVariables> & ({ variables: AuthorProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorProfileQuery, AuthorProfileQueryVariables>(AuthorProfileDocument, options);
      }
export function useAuthorProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorProfileQuery, AuthorProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorProfileQuery, AuthorProfileQueryVariables>(AuthorProfileDocument, options);
        }
// @ts-ignore
export function useAuthorProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthorProfileQuery, AuthorProfileQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorProfileQuery, AuthorProfileQueryVariables>;
export function useAuthorProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorProfileQuery, AuthorProfileQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorProfileQuery | undefined, AuthorProfileQueryVariables>;
export function useAuthorProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorProfileQuery, AuthorProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorProfileQuery, AuthorProfileQueryVariables>(AuthorProfileDocument, options);
        }
export type AuthorProfileQueryHookResult = ReturnType<typeof useAuthorProfileQuery>;
export type AuthorProfileLazyQueryHookResult = ReturnType<typeof useAuthorProfileLazyQuery>;
export type AuthorProfileSuspenseQueryHookResult = ReturnType<typeof useAuthorProfileSuspenseQuery>;
export type AuthorProfileQueryResult = Apollo.QueryResult<AuthorProfileQuery, AuthorProfileQueryVariables>;